import React from "react";
import "./styles.css";
import ResourcesImg from "../../assets/img/resources.svg";

function ResourcesIntro() {
  return (
    <div className="resources-intro">
      <h1>Recursos para tu negocio</h1>
      <p>
        Descubre nuestros contenidos sobre
        <b> marketing, ventas y servicio de atención al cliente. </b>
        Semanalmente compartimos herramientas y consejos útiles para tu negocio.
      </p>
      <img src={ResourcesImg} alt="teamworkers" />
    </div>
  );
}

export default ResourcesIntro;
